import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import * as ST from './styled';
import { openChat } from '~/src/store/actions/chat';
import { connect } from 'react-redux';
import CallRequestByTheme from '../../../components/Popups/CallRequestByTheme';
import { IconVk, IconTelegram, IconViber } from './icons';

export class Support extends Component {
  static propTypes = {
    hasContacts: PropTypes.bool,
    isOpenAddresses: PropTypes.bool,
  };

  static defaultProps = {
    hasContacts: false,
    isOpenAddresses: false,
  };

  state = {
    isCallbackOpen: false,
  };

  onCallbackClick = () => {
    this.setState({ isCallbackOpen: true });
  };

  handleClosePopup = () => {
    this.setState({ isCallbackOpen: false });
  };

  handleAddressClick = () => {
    const { updateOpenAddresses, isOpenAddresses } = this.props;
    updateOpenAddresses(!isOpenAddresses);
  };

  render() {
    const {
      city = {},
      cause,
      children,
      openChat,
    } = this.props;
    const contactEmail = city.email || 'help@domru.ru';
    const phone = city.phone || '';

    return (
      <ST.Container>
        <ST.Header>Как с нами связаться</ST.Header>

        <ST.RowNav>
          <ST.List>
            <ST.ListItem>
              <ST.LinkWithIcon href={'https://vk.me/domru'}>
                <IconVk />
                Написать ВKонтакте
              </ST.LinkWithIcon>
            </ST.ListItem>
            <ST.ListItem>
              <ST.LinkWithIcon href={'https://t.me/dom_ru_bot'}>
                <IconTelegram />
                Написать в Telegram
              </ST.LinkWithIcon>
            </ST.ListItem>
            <ST.ListItem>
              <ST.LinkWithIcon href={'https://chats.viber.com/dom.ru/ru'}>
                <IconViber />
                Написать в Viber
              </ST.LinkWithIcon>
            </ST.ListItem>
          </ST.List>

          <ST.List>
            <ST.ListItem>
              <ST.ItemLink onClick={openChat} data-test='chat'>
                Написать в чат
              </ST.ItemLink>
            </ST.ListItem>

            <ST.ListItem>
              <ST.ItemLink href={`mailto:${contactEmail}`} data-test='email'>
                Написать на почту
              </ST.ItemLink>
            </ST.ListItem>

            <ST.ListItem>
              <ST.ItemLink onClick={this.onCallbackClick}>
                Задать вопрос или сообщить о проблеме
              </ST.ItemLink>
            </ST.ListItem>
            <RenderCause cause={cause} />
          </ST.List>
        </ST.RowNav>

        <ST.RowCallback>
          <ST.Link
            href={`tel:${phone.replace(/[' ']/g, '')}`}
            className='js-calltouch-phone'
            data-test='phone'
          >
            {phone}
          </ST.Link>

          <ST.Link onClick={this.onCallbackClick} data-test='call-back'>
            Заказать обратный звонок
          </ST.Link>
        </ST.RowCallback>

        {children}

        <CallRequestByTheme
          isOpen={this.state.isCallbackOpen}
          onClose={this.handleClosePopup}
          city={city}
          data-test='call-back-popup'
        />
      </ST.Container>
    );
  }
}

/**
 * @param {{link,cause}[]} cause
 * @return {*}
 * @constructor
 */
function RenderCause({ cause }) {
  return cause.map((item, index) => (
    <ST.ListItem key={index}>
      <Link href={item.link} prefetch={false} passHref>
        <ST.ItemLink>{item.cause}</ST.ItemLink>
      </Link>
    </ST.ListItem>
  ));
}

const mapDispatchToProps = (dispatch) => ({
  openChat: () => dispatch(openChat()),
});

export default connect(null, mapDispatchToProps)(Support);
